import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "imgFull",
  "use": "imgFull-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"imgFull\">\r\n<rect x=\"2.5\" y=\"6.5\" width=\"19\" height=\"12\" rx=\"0.5\" stroke=\"currentColor\" />\r\n<rect x=\"4.5\" y=\"8.5\" width=\"15\" height=\"8\" rx=\"0.5\" stroke=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol